import { jsonProperty, Serializable } from 'ts-serializable';

import { SurveyResultDto } from '~modules/surveys/dto/SurveyResultDto';
import { SurveyFormTypeIdEnum } from '~modules/surveys/types/SurveyFormTypeIdEnum';

export class SendSurveyDto extends Serializable {
  @jsonProperty(Number, null) formId: number | null = null;
  @jsonProperty(Number, null) carId: number | null = null;
  @jsonProperty(Number, null) workOrderId: number | null = null;
  @jsonProperty(Number, null) formTypeId: SurveyFormTypeIdEnum | null = null;
  @jsonProperty([SurveyResultDto]) results: SurveyResultDto[] = [];
}
